import { createContext } from 'react';
import { User as FirebaseUser } from 'firebase/auth';
import { UserRole } from '@/shared/constants';

// Re-using types from the main file for consistency
// Note: In a larger refactor, these types would move to a separate types.ts
export interface UserProfile {
    uid: string;
    email: string;
    displayName?: string;
    role: UserRole | string;
    createdAt: string;
    updatedAt: string;
    firstName?: string;
    lastName?: string;
    middleName?: string;
    dateOfBirth?: string;
    address?: string;
    city?: string;
    zipCode?: string;
    isMinor?: boolean;
    parentConsent?: any;
    parentGuardian?: any;
    settings?: any;
    requiresPasswordChange?: boolean;
    [key: string]: any;
}

export interface AuthContextValue {
    user: FirebaseUser | null;
    userProfile: UserProfile | null;
    loading: boolean;
    error: Error | null;
    requiresPasswordChange: boolean;
    showPasswordChangeModal: boolean;
    setShowPasswordChangeModal: React.Dispatch<React.SetStateAction<boolean>>;
    login: (email: string, password: string) => Promise<FirebaseUser>;
    register: (email: string, password: string, additionalData?: any) => Promise<FirebaseUser>;
    logout: () => Promise<void>;
    resetPassword: (email: string) => Promise<void>;
    resendVerificationEmail: () => Promise<void>;
    updateUserProfile: (updates: any) => Promise<UserProfile | null>;
    hasRole: (role: UserRole | UserRole[]) => boolean;
    getUserFullName: () => string;
    isAuthenticated: boolean;
    isAdmin: boolean;
    isInstructor: boolean;
    isStudent: boolean;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
